// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import 'swiper/dist/css/swiper.css'
// import VueResource from 'vue-resource'
import resource from '@/utils/request'
import globalVariable from '@/api/global_variable.js'
import i18n from './i18n' // Internationalization
import { Popover, Divider, link } from 'element-ui'
import './assets/js/iconfont.js'
// import wow from 'wowjs'
// import 'wowjs/css/libs/animate.css'
// Vue.prototype.$wow = wow

Vue.use(Popover)
Vue.use(Divider)
Vue.use(link)

Vue.prototype.$source = resource
Vue.prototype.GLOBAL = globalVariable
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute('content', to.meta.content.keywords)
    document
      .querySelector('meta[name="description"]')
      .setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// Vue.use(VueResource)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-active'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js